export interface Selectable {
  selected: boolean;
}

export function moveItemsBy<T extends Selectable>(items: T[], delta: number): T[] {
  const result = [...items];
  const indices = result.map((m, i) => (m.selected ? i : -1)).filter(i => i !== -1);
  if (indices.length === 0) return result;

  const sorted = delta > 0 ? [...indices].reverse() : indices;

  for (const idx of sorted) {
    const newIdx = idx + delta;
    if (newIdx >= 0 && newIdx < result.length) {
      const a = result[idx];
      const b = result[newIdx];
      if (a !== undefined && b !== undefined) {
        result[idx] = b;
        result[newIdx] = a;
      }
    }
  }
  return result;
}

export function moveItemsTo<T extends Selectable>(items: T[], position: 'top' | 'bottom'): T[] {
  const selected = items.filter(m => m.selected);
  const unselected = items.filter(m => !m.selected);
  return position === 'top' ? [...selected, ...unselected] : [...unselected, ...selected];
}

export function canMoveUp<T extends Selectable>(items: T[]): boolean {
  if (items.length === 0) return false;
  const firstSelectedIndex = items.findIndex(m => m.selected);
  return firstSelectedIndex > 0;
}

export function canMoveDown<T extends Selectable>(items: T[]): boolean {
  if (items.length === 0) return false;
  for (let i = items.length - 1; i >= 0; i--) {
    if (items[i]?.selected) return i < items.length - 1;
  }
  return false;
}
